import type { RunErrorMetadata, RunFinishedMetadata } from "#types/types.ts";

/**
 * The `RUN_ERROR` code core-python sends when the content policy blocked the turn. Must stay in
 * lockstep with `CONTENT_BLOCKED_RUN_ERROR_CODE` in core-python's `run_error_codes.py`.
 */
export const CONTENT_BLOCKED_RUN_ERROR_CODE = "content_blocked";

const asRecord = (metadata: unknown) => (typeof metadata === "object" && metadata !== null ? metadata : {});

/**
 * Reads `RUN_FINISHED.metadata` as core-python publishes it: flat, read-once keys. A key is absent
 * when unknown, so every field is optional.
 */
export const readRunFinishedMetadata = (metadata: unknown): Partial<RunFinishedMetadata> => asRecord(metadata);

/** Reads `RUN_ERROR.metadata`: the tool that failed, when a tool's failure ended the run. */
export const readRunErrorMetadata = (metadata: unknown): Partial<RunErrorMetadata> => asRecord(metadata);
